import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';

const DraggableWrapper = ({ children, className, initialStyle = {}, }) => {
    const [position, setPosition] = useState(null);
    const [startPosition, setStartPosition] = useState({
        x: 0,
        y: 0,
    });
    const [dragging, setDragging] = useState(false);
    const handleDragStart = (e) => {
        var _a, _b;
        const rect = e.currentTarget.getBoundingClientRect();
        const currentX = (_a = position === null || position === void 0 ? void 0 : position.x) !== null && _a !== void 0 ? _a : rect.left;
        const currentY = (_b = position === null || position === void 0 ? void 0 : position.y) !== null && _b !== void 0 ? _b : rect.top;
        setStartPosition({
            x: e.clientX - currentX,
            y: e.clientY - currentY,
        });
        setDragging(true);
    };
    const handleDrag = (e) => {
        if (!dragging)
            return;
        setPosition({
            x: e.clientX - startPosition.x,
            y: e.clientY - startPosition.y,
        });
    };
    const handleDragEnd = () => {
        setDragging(false);
    };
    useEffect(() => {
        if (dragging) {
            window.addEventListener("mousemove", handleDrag);
            window.addEventListener("mouseup", handleDragEnd);
        }
        else {
            window.removeEventListener("mousemove", handleDrag);
            window.removeEventListener("mouseup", handleDragEnd);
        }
        return () => {
            window.removeEventListener("mousemove", handleDrag);
            window.removeEventListener("mouseup", handleDragEnd);
        };
    }, [dragging, startPosition]);
    const dynamicStyle = position
        ? {
            left: `${position.x}px`,
            top: `${position.y}px`,
            transform: "none",
        }
        : initialStyle;
    return (jsx("span", Object.assign({ className: className, onMouseDown: handleDragStart, style: Object.assign({ position: "fixed", zIndex: Number.MAX_SAFE_INTEGER, cursor: dragging ? "grabbing" : "grab" }, dynamicStyle) }, { children: children })));
};

export { DraggableWrapper as default };
//# sourceMappingURL=DraggableWrapper.js.map
